module.exports = __webpack_public_path__ + "img/icon11.703768f1.png";